var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn black",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.clickAction($event)}}},[_c('span',[_vm._t("icon")],2),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }